import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import PanelBarItemViewModel from '@/ViewModels/Controls/PanelBarItemViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class PanelBarViewModel extends ControlViewModel {

    /**
     * Die Items der PanelBar
     */
    public items: KnockoutObservable<Array<PanelBarItemViewModel>>;

    /**
     * Das ViewModel für die PanelBar
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.items = this.observableOrDefault(params.items, []);
    }

    /**
     * Erzeugt ein neues, geschachteltes PanelBarViewModel anhand des vom Server gelieferten "userNavigationTree"
     */
    public static parseUserNavigationTree(userFavoriteTree: any): PanelBarViewModel {
        let PanelBarItemViewModel = ComponentManager.getViewModel('PanelBarItemViewModel');
        let LinkViewModel = ComponentManager.getViewModel('LinkViewModel');
        let ImageViewModel = ComponentManager.getViewModel('ImageViewModel');
        let LabelViewModel = ComponentManager.getViewModel('LabelViewModel');

        let panelBar = PanelBarViewModel.createPanelBar(userFavoriteTree)

        return panelBar;
    }

    private static createPanelBar(panelBar: any): PanelBarViewModel {
        if (panelBar.childNodes != null && panelBar.childNodes.length > 0) {
            return new PanelBarViewModel({
                items: PanelBarViewModel.createItems(panelBar.childNodes)
            });
        }

        return null;
    }

    private static createItems(items: Array<any>): Array<PanelBarItemViewModel> {
        let menuItems = [];

        if (items != null) {
            for (let i = 0; i < items.length; i++) {
                let item = PanelBarViewModel.createItem(items[i]);
                menuItems.push(item);
            }
        }

        return menuItems;
    }

    private static createItem(item: any): PanelBarItemViewModel {
        let panelBarItem = new PanelBarItemViewModel({
            link: new LinkViewModel({
                image: new ImageViewModel({
                    source: item.iconUrl,
                    alternativeText: new LabelViewModel({
                        ergName: item.ergName
                    })
                }),
                label: new LabelViewModel({
                    ergName: item.ergName
                })
            })
        });

        return panelBarItem;
    }
}

ComponentManager.setViewModel('PanelBarViewModel', PanelBarViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');